import { useEffect, useState } from 'react';
import { OverlayTrigger, Tooltip } from 'react-bootstrap';
import styled from 'styled-components';
import { getInitials } from '../../../Components/UserImage';

function Role({ title = 'NA', id, activeRole, handleRoleChange }) {
  const [isActive, setIsActive] = useState(activeRole === title);
  const TITLE = title.replace('_', ' ');
  useEffect(() => {
    setIsActive(title === activeRole);
  }, [title, activeRole]);

  return (
    <OverlayTrigger
      key={id}
      placement="top"
      delay={{ show: 150, hide: 50 }}
      overlay={
        <Tooltip id="button-tooltip ">
          <div className="text-capitalize">{TITLE}</div>
        </Tooltip>
      }>
      <StyledRole
        className={` ${isActive ? 'active' : ''} ${title}`}
        onClick={() => handleRoleChange(title)}>
        <span>{getInitials(TITLE)}</span>
      </StyledRole>
    </OverlayTrigger>
  );
}

export default Role;

const StyledRole = styled.div`
  width: 40px;
  min-width: 40px;
  height: 40px;
  border-radius: 1000px;
  display: flex;
  justify-content: center;
  align-items: center;
  font-size: 18px;
  margin-right: 5px;
  cursor: pointer;
  background: #e12a2a;
  color: white;
  transition: transform 200ms;
  &.active {
    transform: translateY(-4px);
    transform-origin: center;
    border: 3px solid #2078f9;
    color: white !important;
  }
  :hover {
    transform: scale(1.1);
  }
  :active {
    transform: scale(0.9);
    color: white;
  }
  &.superuser {
    background: #e50000;
  }
  &.participant {
    background: #e12a2a;
  }
  &.resource_person {
    background: #0d6efd;
    color: white;
  }
  &.executive {
    background: #f44336;
  }
  &.cd_admin {
    background: #9c27b0;
  }
  &.development_partner {
    background: #03a9f4;
  }
`;
